import { render } from "./MySend.vue?vue&type=template&id=5e6c4584&ts=true"
import script from "./MySend.vue?vue&type=script&lang=ts"
export * from "./MySend.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__